"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMaxAmount = useMaxAmount;
var _bignumber = require("bignumber.js");
var _reactRedux = require("react-redux");
var _selectors = require("../../../redux/margin/selectors");
var _useOrderProducts2 = require("../common/useOrderProducts");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _react = require("react");
/**
 * Returns raw and formatted max amount available for margin trading for the selected instrument.
 * @returns {{ value: number; formatted: string; symbol: string; }}
 */
function useMaxAmount() {
  var _useOrderProducts = (0, _useOrderProducts2.useOrderProducts)(),
    product1 = _useOrderProducts.product1;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.marginAccountEquitySelector),
    MaxAmount = _useSelector.MaxAmount;
  return (0, _react.useMemo)(function () {
    return {
      value: new _bignumber.BigNumber(MaxAmount !== null && MaxAmount !== void 0 ? MaxAmount : 0).dp((product1 === null || product1 === void 0 ? void 0 : product1.DecimalPlaces) || 8).toNumber(),
      formatted: (0, _numberFormatter.formatNumberToLocale)(MaxAmount, product1 === null || product1 === void 0 ? void 0 : product1.DecimalPlaces),
      symbol: product1 === null || product1 === void 0 ? void 0 : product1.Product
    };
  }, [MaxAmount, product1 === null || product1 === void 0 ? void 0 : product1.DecimalPlaces, product1 === null || product1 === void 0 ? void 0 : product1.Product]);
}